// extracted by mini-css-extract-plugin
export default {"comparisonPane":"AdhocComparison_comparisonPane__Ms2O6"};